import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '../../_shared/hooks';
import { saveWaterfallRows } from '../api-client';
import type { WaterfallRow } from '../components/waterfallTypes';
import type { StatusMapping } from '../components/types';

export function useSaveLauncherWaterfall(id: string) {
  const { apiFetch } = useApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ rows, statusMapping }: { rows: WaterfallRow[]; statusMapping?: StatusMapping }) =>
      saveWaterfallRows(apiFetch, id, rows, statusMapping),
    onSuccess: (data) => {
      queryClient.setQueryData(['launcher', 'campaigns', id, 'waterfall'], { rows: data.rows, status_mapping: data.status_mapping });
      void queryClient.invalidateQueries({ queryKey: ['launcher', 'campaigns', id, 'waterfall'] });
    },
  });
}
